export default [{
  path: '/profile/:id',
  name: 'profile',
  meta: {
    layout: 'main',
    title: 'Профиль'
  },  
  component: () => import('@/views/profile/index')
}]
